import type { DriveContext, GoogleDriveNodeFlat } from './types';
import { googleFetch } from '../client';

export type GoogleDriveNodesListRequest = DriveContext & {
  root_folder_id: string;
};

export type GoogleDriveNodesListResponse = {
  items: GoogleDriveNodeFlat[];
};

export async function googleDriveNodesList(
  params: GoogleDriveNodesListRequest
): Promise<GoogleDriveNodesListResponse> {
  return googleFetch<GoogleDriveNodesListResponse>(
    '/rpc/google_drive_nodes_list',
    {
      body: params,
    }
  );
}
